function apiFactory({ makeRequest }) {
  const apiCommonMethods = [
    ['getMyself', '/myself'],
    ['getMyPermissions', '/mypermissions'],
    ['searchForFilters', '/filter/search'],
    ['searchForUsers', '/groupuserpicker'],
    ['searchForIssues', '/search'],
    ['getIssueByIdOrKey', '/issue/{issueIdOrKey}'],
    ['getIssueWorklogs', '/issue/{issueIdOrKey}/worklog'],
    ['deleteIssueWorklog', '/issue/{issueIdOrKey}/worklog/{worklogId}', 'DELETE'],
    ['addIssueWorklog', '/issue/{issueIdOrKey}/worklog/', 'POST'],
    ['updateIssueWorklog', '/issue/{issueIdOrKey}/worklog/{worklogId}', 'PUT'],
    ['searchForProjects', '/project/search'],
    ['getAllProjects', '/project'],
    ['getProjectByIdOrKey', '/project/{projectIdOrKey}'],
    ['getProjectVersions', '/project/{projectIdOrKey}/version'],
    ['getProjectComponents', '/project/{projectIdOrKey}/component'],
    ['getComponentById', '/component/{id}'],
    ['getVersionById', '/version/{id}'],
    ['getAllIssueTypesForUser', '/issuetype'],
    ['getAllIssueFields', '/field'],
    ['getUserByAccountId', '/user'],
    ['getAllIssueStatuses', '/status'],
    ['getAllBoards', '/board', 'GET', '/rest/agile/1.0'],
    ['getBoardById', '/board/{boardId}', 'GET', '/rest/agile/1.0'],
    ['getAllSprints', '/board/{boardId}/sprint', 'GET', '/rest/agile/1.0'],
    ['getSprintById', '/sprint/{sprintId}', 'GET', '/rest/agile/1.0'],
    ['getFilterById', '/filter/{id}'],
    ['getWorklogActivity', '/worklogActivity', 'PUT', '/plugins/servlet/chronos'],
    ['deleteScreenshot', '/deleteScreenshot', 'POST', '/plugins/servlet/chronos'],
    ['getServerSettings', '/settings', 'GET', '/plugins/servlet/chronos'],
    ['getAllUsersServerSettings', '/usersettings/all', 'GET', '/plugins/servlet/chronos'],
    ['saveUsersSettings', '/usersettings', 'POST', '/plugins/servlet/chronos'],
    ['saveServerSettings', '/settings', 'POST', '/plugins/servlet/chronos'],
    ['testS3Bucket', '/testS3Bucket', 'GET', '/plugins/servlet/chronos/settings'],
    ['migrateToS3', '/migrateToS3', 'GET', '/plugins/servlet/chronos/settings'],
  ];

  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  let rootApiUrl = '';
  let baseApiUrl = '/rest/api/3';
  let mockMethods = {};

  function fillUrlTemplate(
    template,
    templateVars,
  ) {
    const re = new RegExp('{', 'g');
    return (
      new Function( /* eslint-disable-line */
        `return \`${template.replace(re, '${this.')}\`;`,
      ).call(templateVars)
    );
  }

  function buildQueryUrl(
    params = {},
    endpointUrl,
    baseUrl,
  ) {
    const urlInstance = new URL(
      baseUrl.includes('http')
        ? (
          `${baseUrl}${fillUrlTemplate(endpointUrl, params)}`
        ) : (
          `http://localhost${baseUrl}${fillUrlTemplate(endpointUrl, params)}`
        ),
    );

    urlInstance.search = new URLSearchParams(params);
    if (baseUrl.includes('http')) {
      return urlInstance.toString();
    }
    const [
      domain, /* eslint-disable-line */
      ...restUrl
    ] = urlInstance.toString().split('localhost');
    return restUrl.join('');
  }

  function performFetch({
    methodName,
    endpointUrl,
    baseUrl,
    method,
    params,
    body,
  }) {
    const url = buildQueryUrl(
      params,
      endpointUrl,
      `${rootApiUrl}${baseUrl}`,
    );

    if (mockMethods[methodName]) {
      return mockMethods[methodName]({
        ...params,
        url,
        endpointUrl,
      });
    }

    return makeRequest(
      url,
      {
        method,
        headers,
        ...(
          Object.keys(body).length
            ? ({
              data: JSON.stringify(body),
            })
            : {}
        ),
      },
    );
  }

  return ({
    setHeaders(newHeaders) {
      headers = newHeaders;
      return headers;
    },

    setBaseUrl(newBaseUrl, newRootUrl) {
      baseApiUrl = newBaseUrl;
      if (newRootUrl) {
        rootApiUrl = newRootUrl;
      }
      return baseApiUrl;
    },

    setMockMethods(
      mockObject,
      merge = true,
    ) {
      mockMethods = merge ? {
        ...mockMethods,
        ...mockObject,
      } : mockObject;

      return mockMethods;
    },

    clearMockMethods() {
      mockMethods = {};
      return mockMethods;
    },

    ...(
      apiCommonMethods.reduce((
        acc,
        [
          methodName,
          endpointUrl,
          method = 'GET',
          baseUrl,
        ],
      ) => ({
        ...acc,
        [methodName]({
          params = {},
          body = {},
        } = {
          params: {},
          body: {},
        }) {
          return performFetch({
            methodName,
            endpointUrl,
            baseUrl: baseUrl || baseApiUrl,
            method,
            params,
            body,
          });
        },
      }), {})
    ),
  });
}

export default apiFactory;
